// Module
var code = "<branch-values kind=\"'countries'\"></branch-values>\n";
// Exports
module.exports = code;